// This file is auto generated using CMS based event tracking.
// Do not modify this file manually!
import { BaseTrackingContext } from '@goeuro/app/client/tracking-provider/src/cms/lib/BaseTrackingContext';

/* Properties block */
export type PaymentContextProperties = {
  selected_payment_method_option?: string;
  payment_method_options?: string;
  is_stored_card_selected?: boolean;
  is_invoice_selected?: boolean;
  added_billing_address?: boolean;
  payment_method?: string;
};

/* Context definition block */
const schema = 'iglu:com.goeuro/payment_context/jsonschema/2-0-0';
export const paymentContextName = 'payment_context';
export class PaymentContext extends BaseTrackingContext<PaymentContextProperties> {
  constructor(properties: PaymentContextProperties) {
    super(paymentContextName, schema, properties);
  }
}
